module.exports = __webpack_public_path__ + "img/chevron-left_active.45c9ad8e.svg";